import { render, staticRenderFns } from "./SlideHeaderWithNav.vue?vue&type=template&id=6fdc3c83&scoped=true&"
import script from "./SlideHeaderWithNav.vue?vue&type=script&lang=ts&"
export * from "./SlideHeaderWithNav.vue?vue&type=script&lang=ts&"
import style0 from "./SlideHeaderWithNav.vue?vue&type=style&index=0&id=6fdc3c83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc3c83",
  null
  
)

export default component.exports